module.exports = __webpack_public_path__ + "img/primary_11x1_z18.010a5e13.svg";